import axios from "axios";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const { REACT_APP_API_ENDPOINT } = process.env;

export const getMission = createAsyncThunk("get/mission", async () => {
  const resp = await axios.get(
    `${REACT_APP_API_ENDPOINT}/api/v2/posts/mission/`
  );
  return resp.data;
});

const initialState = {
  missionList: [],
};

const MissionListSlice = createSlice({
  name: "MissionList",
  initialState,
  reducers: {
    resetState: () => initialState,
  },
  extraReducers: {
    [getMission.fulfilled]: (state, action) => {
      state.missionList = action.payload;
    },
    [getMission.rejected]: () => {
      alert("Get mission failed!");
    },
  },
});

export default MissionListSlice.reducer;
